<div class="form-group">
  <div><small *ngIf="label">{{label}}</small></div>

  <label class="switch switch-label switch-pill switch-primary bottom m-0">
    <ng-container *ngIf="controlName">
      <input type="checkbox"
             class="switch-input"
             [formControl]="controlName"
             [(ngModel)]="model[bindValue]"
             (ngModelChange)="ModelChange()"
             [attr.disabled]="isDisabled ? true : null">
    </ng-container>

    <ng-container *ngIf="!controlName">
      <input type="checkbox"
             class="switch-input"
             [(ngModel)]="model[bindValue]"
             (ngModelChange)="ModelChange()"
             [attr.disabled]="isDisabled ? true : null"
     >
    </ng-container>

    <span class="switch-slider"></span>
  </label>
</div>

